export const enum AppErrorType {
  BAD_CONFIGURATION = 'BAD_CONFIGURATION',
  GENERIC_ERROR = 'GENERIC_ERROR',
  RELOAD_PAGE = 'RELOAD_PAGE',
}

export type AppErrorCtaCallback = () => void

export type CustomErrorAction = {
  label: string
  onClick: () => void
  color?: 'primary' | 'secondary' | 'tertiary'
  asLink?: boolean
  underline?: boolean
}

export type AppError = {
  error?: string | Error
  errorType?: AppErrorType

  // for single CTA on error page
  ctaCallback?: AppErrorCtaCallback

  // for custom CTAs
  customActions?: CustomErrorAction[]
}

export type ErrorPageCtaOptions = {
  // for single CTA on error page
  ctaLabel?: string
  ctaOnClick?: () => void

  // for custom CTAs
  customActions?: CustomErrorAction[]
}

export type ErrorPageContentOptions = {
  title?: string
  message?: string | string[]
}

export type ErrorPageState = {
  errorType?: AppErrorType
  title?: string
  message?: string | string[]
  ctaLabel?: string
}
